import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LottieComponent, AnimationOptions } from 'ngx-lottie';
import { TranslateModule } from '@ngx-translate/core';
import { PageShell } from '../page-shell/page-shell';

@Component({
  selector: 'app-no-permission',
  standalone: true,
  imports: [CommonModule, LottieComponent, TranslateModule, PageShell],
  templateUrl: './no-permission.component.html'
})
export class NoPermissionComponent {
  /** ?reason=plan: the module is outside the clinic's plan, which no role can grant. */
  protected readonly planReason = inject(ActivatedRoute).snapshot.queryParamMap.get('reason') === 'plan';

  options: AnimationOptions = {
    path: '/assets/jsons/Error_404.json', // Path to your Lottie JSON
  };
}
